// extracted by mini-css-extract-plugin
module.exports = {"root":"IconReviewStar_root__O03cX","filled":"IconReviewStar_filled__3DpIL"};